export default [
  {
    path: 'consultorias/crear-entregables-rrhh/:id',
    name: 'consultorias-crearEntregablesRrhh',
    component: () => import('../crear-entregables-rrhh/views/index.vue'),
  },
  {
    path: 'consultorias/crear-entregables-rrhh/:id/detalle/:entregableId',
    name: 'consultorias-detalleEntregable',
    component: () =>
      import('../crear-entregables-rrhh/views/detalleEntregable.vue'),
  },
  {
    path: 'consultorias/crear-entregables-rrhh/:id/designar-consultores',
    name: 'consultorias-designarConsultores',
    component: () =>
      import('../crear-entregables-rrhh/views/designarConsultores.vue'),
  },
];
